import { jsx as O } from "react/jsx-runtime";
import { createContext as D, useRef as y, useCallback as p, useEffect as T, useMemo as H, useContext as W, useId as _ } from "react";
import { z as l } from "zod";
import { twMerge as R } from "tailwind-merge";
const P = D(void 0), U = ({ children: C }) => {
  const s = y(/* @__PURE__ */ new Map()), v = y([]), d = y(/* @__PURE__ */ new Set()), i = y(null), r = p(() => {
    const e = s.current, t = v.current;
    let n = 0;
    for (let c = 0; c < t.length; c++) {
      const a = t[c], o = e.get(a);
      o && (o.element.style.top = `${n}px`, o.element.style.zIndex = `${50 - c}`, n += o.height);
    }
  }, []), u = p(() => {
    const e = s.current, t = Array.from(e.keys());
    t.sort((n, c) => {
      var f, m;
      const a = (f = e.get(n)) == null ? void 0 : f.element, o = (m = e.get(c)) == null ? void 0 : m.element;
      if (!a || !o)
        return 0;
      const g = a.compareDocumentPosition(o);
      return g & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : g & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
    }), v.current = t;
  }, []), h = p(() => (i.current || (i.current = new ResizeObserver((e) => {
    var n;
    let t = !1;
    for (const c of e) {
      const a = c.target, o = a.dataset.stickyId;
      if (!o || d.current.has(o))
        continue;
      const g = s.current.get(o);
      if (!g)
        continue;
      const f = (n = c.borderBoxSize) == null ? void 0 : n[0], m = f ? f.blockSize : a.offsetHeight;
      g.height !== m && (g.height = m, t = !0);
    }
    t && r();
  })), i.current), [r]);
  T(() => () => {
    var e;
    (e = i.current) == null || e.disconnect();
  }, []);
  const k = p(
    (e, t) => {
      const n = t.offsetHeight;
      s.current.set(e, { id: e, element: t, height: n }), t.dataset.stickyId = e, u(), h().observe(t, { box: "border-box" }), r();
    },
    [u, r, h]
  ), x = p(
    (e) => {
      const t = s.current.get(e);
      t && h().unobserve(t.element), s.current.delete(e), d.current.delete(e), u(), r();
    },
    [u, r, h]
  ), I = p(
    (e, t) => {
      const n = s.current.get(e);
      !n || n.height === t || (n.height = t, r());
    },
    [r]
  ), S = p((e, t) => {
    t ? d.current.add(e) : d.current.delete(e);
  }, []), E = H(
    () => ({
      register: k,
      unregister: x,
      notifyHeightChange: I,
      setTransitioning: S
    }),
    [k, x, I, S]
  );
  return /* @__PURE__ */ O(P.Provider, { value: E, children: C });
}, $ = l.object({
  children: l.custom().optional(),
  className: l.string().optional(),
  forwardedRef: l.any().optional(),
  style: l.custom().optional(),
  collapsed: l.boolean().optional(),
  overlay: l.boolean().optional(),
  transitionHeight: l.number().optional(),
  transitionDuration: l.number().optional()
}).passthrough(), F = ({
  children: C,
  forwardedRef: s,
  className: v,
  style: d,
  collapsed: i,
  overlay: r,
  transitionHeight: u,
  transitionDuration: h = 300,
  ...k
}) => {
  const x = W(P);
  if (!x)
    throw new Error("StickyWrapper must be used within a StickyProvider");
  const { register: I, unregister: S, notifyHeightChange: E, setTransitioning: e } = x, t = _(), n = y(null), c = p(
    (f) => {
      n.current = f, s && typeof s == "object" && "current" in s && (s.current = f);
    },
    [s]
  );
  T(() => {
    if (!(!n.current || r))
      return I(t, n.current), () => S(t);
  }, [t, I, S, r]);
  const a = y(u), o = y(i);
  if (T(() => {
    var z;
    if (r)
      return;
    const f = a.current !== u, m = o.current !== i;
    if (a.current = u, o.current = i, !f && !m)
      return;
    const w = i ? 0 : u !== void 0 ? u : ((z = n.current) == null ? void 0 : z.offsetHeight) ?? 0;
    e(t, !0), E(t, w);
    const b = n.current;
    if (!b)
      return;
    const N = (M) => {
      M.target === b && (e(t, !1), b.removeEventListener("transitionend", N));
    };
    b.addEventListener("transitionend", N);
    const L = setTimeout(() => {
      e(t, !1), b.removeEventListener("transitionend", N);
    }, h + 50);
    return () => {
      clearTimeout(L), b.removeEventListener("transitionend", N);
    };
  }, [
    u,
    i,
    h,
    t,
    r,
    e,
    E
  ]), r)
    return /* @__PURE__ */ O(
      "div",
      {
        ref: c,
        style: {
          position: "fixed",
          left: 0,
          right: 0,
          zIndex: 50,
          ...d
        },
        className: R(v),
        "data-sticky-wrapper": !0,
        ...k,
        children: C
      }
    );
  const g = {
    ...d,
    position: "sticky",
    top: 0
  };
  return /* @__PURE__ */ O(
    "div",
    {
      ref: c,
      style: g,
      className: R(v),
      "data-sticky-wrapper": !0,
      ...k,
      children: C
    }
  );
};
export {
  U as StickyProvider,
  F as StickyWrapper,
  $ as stickyWrapperSchema
};
//# sourceMappingURL=index.es.js.map
